export default __webpack_public_path__ + "static/media/settings.83a5101c.svg";